import { render, staticRenderFns } from "./UserManintenanceTabsComponent.vue?vue&type=template&id=5b49d8fe&lang=pug"
import script from "./UserManintenanceTabsComponent.vue?vue&type=script&lang=ts"
export * from "./UserManintenanceTabsComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b49d8fe')) {
      api.createRecord('5b49d8fe', component.options)
    } else {
      api.reload('5b49d8fe', component.options)
    }
    module.hot.accept("./UserManintenanceTabsComponent.vue?vue&type=template&id=5b49d8fe&lang=pug", function () {
      api.rerender('5b49d8fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/maintenance/Users/components/UserManintenanceTabsComponent.vue"
export default component.exports